import { getRetailer } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getRetailer";
import { ISearchSuggestionResponse } from "@faire/web-api--source/indigofair/data/ISearchSuggestionResponse";

export const shouldShowSearchRecommendations = (
  searchRecommendations:
    | ISearchSuggestionResponse.ISearchRecommendation[]
    | undefined
) => searchRecommendations && searchRecommendations?.length > 0;

export const getSuggestionUrl = (url: string) => {
  if (!url.startsWith("/")) {
    const retailerToken = getRetailer()?.token;
    const urlPrefix = retailerToken ? `/retailer/${retailerToken}` : "/";
    url = `${urlPrefix}${url}`;
  }
  return url.replace("//", "/");
};
